export const Field = ({ label, children, className = "" }) => (
  <label className={`block space-y-1.5 ${className}`}>
    <span className="label-xs">{label}</span>
    {children}
  </label>
);

export const EmptyState = ({ icon: Icon, title, text, children, testid }) => (
  <div className="rounded-2xl border border-dashed border-[#b8956f] bg-[#edf2ef]/40 p-8 text-center" data-testid={testid}>
    {Icon && <Icon className="mx-auto mb-3 h-8 w-8 text-[#3d655b]" />}
    <div className="font-semibold">{title}</div>
    {text && <p className="mt-1 text-sm text-slate-500">{text}</p>}
    {children && <div className="mt-4 flex justify-center">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, testid, dark = false }) => (
  <div className={`rounded-2xl border p-6 shadow-sm ${dark ? "border-[#2b4640] bg-[#2b4640] text-white" : "border-[#e2e8f0] bg-white"}`} data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className={`text-[11px] font-semibold uppercase tracking-[0.14em] ${dark ? "text-white/60" : "text-[#64748b]"}`}>{label}</span>
      {Icon && <Icon className={`h-5 w-5 ${dark ? "text-[#b8956f]" : "text-[#3d655b]"}`} />}
    </div>
    <div className="mt-4 text-4xl font-extrabold tracking-tight">{value}</div>
  </div>
);
